<script lang="ts" setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import OmniDialog from "@/components/omni/OmniDialog.vue";
import { useSeals } from "@/composables/useSeals";
import { DialogSize } from "@/constants/dialog";
import type { StopInfoSeal } from "@/types/trip";

const model = defineModel<boolean>({ required: true });

const props = defineProps<{
  tripId: string | number;
  seal: StopInfoSeal;
}>();

const emit = defineEmits<{
  (e: "deleted", seal: StopInfoSeal): void;
}>();

const { t } = useI18n();
const { deleteSeal } = useSeals();

const isDeleting = ref<boolean>(false);

async function confirm(): Promise<void> {
  isDeleting.value = true;

  const isDeleted = await deleteSeal(props.tripId, props.seal);

  isDeleting.value = false;

  if (!isDeleted) {
    return;
  }

  emit("deleted", props.seal);
  model.value = false;
}
</script>

<template>
  <omni-dialog
    v-model="model"
    :primary-action-label="t('general.delete')"
    :primary-button-loading="isDeleting"
    :secondary-action-label="t('general.cancel')"
    :secondary-button-disabled="isDeleting"
    :size="DialogSize.small"
    :title="t('trip.delete-seal-dialog-title')"
    data-qa="delete-seal-dialog"
    @primary-action:click="confirm"
    @secondary-action:click="model = false"
  >
    <div class="text-grey-darken-1">
      {{ t("trip.delete-seal-dialog-message", { number: props.seal.number }) }}
    </div>
  </omni-dialog>
</template>

<style lang="scss" scoped></style>
